export class CreateBackupZeroEtlPolicyInput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "enabled",
            "baseName": "enabled",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "scope",
            "baseName": "scope",
            "type": "BackupZeroEtlPolicyScope",
            "format": ""
        },
        {
            "name": "multiResourceConfiguration",
            "baseName": "multiResourceConfiguration",
            "type": "MultiResourceBackupZeroEtlConfiguration",
            "format": ""
        },
        {
            "name": "singleResourceConfiguration",
            "baseName": "singleResourceConfiguration",
            "type": "SingleResourceBackupZeroEtlConfiguration",
            "format": ""
        },
        {
            "name": "catalogConfiguration",
            "baseName": "catalogConfiguration",
            "type": "BackupZeroEtlCatalogConfiguration",
            "format": ""
        },
        {
            "name": "storageConfiguration",
            "baseName": "storageConfiguration",
            "type": "BackupZeroEtlStorageConfiguration",
            "format": ""
        },
        {
            "name": "accessConfiguration",
            "baseName": "accessConfiguration",
            "type": "BackupZeroEtlAccessConfiguration",
            "format": ""
        },
        {
            "name": "tableFilters",
            "baseName": "tableFilters",
            "type": "BackupZeroEtlFilters",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CreateBackupZeroEtlPolicyInput.attributeTypeMap;
    }
    constructor() {
    }
}
